import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { useClient } from '@context/presentation';
import { SectionHeader } from '../styles';
import { FicoCreditSection, FicoStyle } from './styles';
import { STATIC_IMAGES, UNAVAILABLE_CS_FIRM } from '@constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faDotCircle } from '@fortawesome/free-solid-svg-icons';
import { generateSlideImageUrl } from '@utils/generateAssetLinks';

const UnorderedList = styled.ul`
    list-style-type: none;
    padding-inline-start: 20px;
`;

const CheckListItemStyle = styled.li`
    svg {
        padding-right: 10px;
        ${({ width }) => (
            `height: ${width};
            width: ${width} !important;`
            )
        }
    }
    display: flex;
    align-items: flex-start;
    padding-bottom: 10px;
    font-size: ${({ fontSize }) => fontSize ? fontSize : '14px'};
`;

export const Fico = () => {
    const { t } = useTranslation();
    const { language, firmShortName } = useClient();
    const { data, desktop } = useSlideData();
    const { creditScore, factors } = data.details;
    const chartFileName = `${STATIC_IMAGES.ficoChart}-${language.toLowerCase()}.png`;

    const CheckListItem = ({ text, icon, fontSize, width }) => (
        <CheckListItemStyle fontSize={fontSize} width={width}>
            <FontAwesomeIcon icon={icon}/> 
            <div>{text}</div>
        </CheckListItemStyle>
    )

    if (firmShortName === UNAVAILABLE_CS_FIRM) {
        return <div>Information not available</div>
    }

    const steps = [t('fico.steps_forward.1'), t('fico.steps_forward.2'), t('fico.steps_forward.3')];

    return (
        <FicoStyle desktop={desktop}>
            <div>
                <SectionHeader margin='0'>{t('fico.three_steps_forward_header')}</SectionHeader>
                <UnorderedList>
                    {
                        steps.map(step => (
                            <CheckListItem
                                key={step}
                                text={step}
                                icon={faCheckCircle}
                                width='24px'/>
                        ))
                    }
                </UnorderedList>
                <SectionHeader margin='0'>{t('fico.concern_areas_header')}</SectionHeader>
                <UnorderedList>
                    { 
                        factors.map(factor => (
                            <CheckListItem
                                fontSize='13px'
                                width='20px'
                                key={factor}
                                text={factor}
                                icon={faDotCircle} />
                        ))
                    }
                </UnorderedList>
            </div>
            <FicoCreditSection>
                <h3>{t('fico.credit_score')}</h3>
                <div id='credit-score'>{creditScore}</div>
                <img alt='fico-chart' src={generateSlideImageUrl(chartFileName)} />
            </FicoCreditSection>
        </FicoStyle>
    );
};

export default Fico;
